import { render, staticRenderFns } from "./Textual.vue?vue&type=template&id=386cdb52&"
import script from "./textual.js?vue&type=script&lang=js&"
export * from "./textual.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports